<template>

  <section>
    <b-modal
      id="modal-center"
      ref="modalbienvenida"
      centered
      title="Mensaje de bienvenida"
      size="lg"
      button-size="sm"
      ok-only
      ok-title="Cerrar"
    >
      <div>
        <b-embed
          v-if="(video.url != '')"
          type="iframe"
          aspect="16by9"
          :src="video.url"
          allowfullscreen
        />
        <b-alert
          variant="primary"
          class="mt-1"
          show
        >
          <div class="alert-body">
            Si no puede escuchar el audio del vídeo, puede subir del volúmen desde la configuración del mismo.
          </div>
        </b-alert>
      </div>
    </b-modal>
  </section>
</template>

<script>
import {
  BAlert, BEmbed, BModal, VBModal,
} from 'bootstrap-vue'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { getData } from '@core/utils/http/general'
import {
  onMounted, ref, getCurrentInstance, watch,
} from '@vue/composition-api'

/* eslint-disable global-require */
export default {
  name: 'DashAlumno',
  components: {
    BAlert,
    BEmbed,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    vervideo: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const video = ref({ url: '' })
    const vm = getCurrentInstance().proxy
    const videoBienvenida = () => {
      getData({ action: 14, token: store.state.cuenta.session.token }, 'wsadminpagecampus')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) { [video.value] = response.data.data }
        })
    }
    const visualizarVideo = ineed => {
      if (ineed) {
        vm.$refs.modalbienvenida.show()
      } else
      // eslint-disable-next-line no-useless-escape
      if (document.cookie.replace(/(?:(?:^|.*;\s*)banderaVideo\s*\=\s*([^;]*).*$)|^.*$/, '$1') !== 'true') {
        vm.$refs.modalbienvenida.show()
        document.cookie = 'banderaVideo=true; max-age=60*60*24*365'
      }
    }

    onMounted(() => {
      visualizarVideo(false)
      videoBienvenida()
    })

    watch(() => props.vervideo, newVal => {
      if (newVal) {
        visualizarVideo(true)
        emit('update:vervideo', false)
      }
    })
    return {
      visualizarVideo,
      video,
    }
  },
}
</script>
<style scoped>
.importanteItem {
  border: 1px solid #7367f0;
}
</style>
<style lang="scss">
@import '@core/scss/vue/pages/page-knowledge-base.scss';
@import '@core/scss/vue/libs/tour.scss';
</style>
